export default __webpack_public_path__ + "static/media/thumbs-up-icon.650ef7c9.gif";